var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 44,
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3534_126054)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 44,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3667 26.0742C29.8 25.6826 30.3667 25.4326 31 25.4326C32.3417 25.4326 33.4333 26.5242 33.4333 27.8659C33.4333 29.2076 32.3417 30.2992 31 30.2992C29.6583 30.2992 28.5667 29.2076 28.5667 27.8659C28.5667 27.6826 28.5917 27.4992 28.6333 27.3242L22.7 23.8576C22.25 24.2742 21.6583 24.5326 21 24.5326C19.6167 24.5326 18.5 23.4159 18.5 22.0326C18.5 20.6492 19.6167 19.5326 21 19.5326C21.6583 19.5326 22.25 19.7909 22.7 20.2076L28.575 16.7826C28.5333 16.5909 28.5 16.3992 28.5 16.1992C28.5 14.8159 29.6167 13.6992 31 13.6992C32.3833 13.6992 33.5 14.8159 33.5 16.1992C33.5 17.5826 32.3833 18.6992 31 18.6992C30.3417 18.6992 29.75 18.4409 29.3 18.0242L23.425 21.4492C23.4667 21.6409 23.5 21.8326 23.5 22.0326C23.5 22.2326 23.4667 22.4242 23.425 22.6159L29.3667 26.0742ZM31.8333 16.1992C31.8333 15.7409 31.4583 15.3659 31 15.3659C30.5417 15.3659 30.1667 15.7409 30.1667 16.1992C30.1667 16.6576 30.5417 17.0326 31 17.0326C31.4583 17.0326 31.8333 16.6576 31.8333 16.1992ZM21 22.8659C20.5417 22.8659 20.1667 22.4909 20.1667 22.0326C20.1667 21.5742 20.5417 21.1992 21 21.1992C21.4583 21.1992 21.8333 21.5742 21.8333 22.0326C21.8333 22.4909 21.4583 22.8659 21 22.8659ZM30.1667 27.8826C30.1667 28.3409 30.5417 28.7159 31 28.7159C31.4583 28.7159 31.8333 28.3409 31.8333 27.8826C31.8333 27.4242 31.4583 27.0492 31 27.0492C30.5417 27.0492 30.1667 27.4242 30.1667 27.8826Z",
    fill: "#696F88"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 43,
    rx: 3.5,
    stroke: "#C2C7D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3534_126054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 44,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBtn);
export default __webpack_public_path__ + "static/media/share_btn.76fbda7996908d778cfd4b5acbbda1da.svg";
export { ForwardRef as ReactComponent };